import type { EmbarcacaoPropulsaoField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const PROPULSAO_ID = "propulsao";
export const PROPULSAO_TITLE = "Propulsão";
export const PROPULSAO_TEST_ID = "embarcacao-propulsao";
export const PROPULSAO_LOADING_MESSAGE = "Carregando a Propulsão da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const PROPULSAO_EMPTY_STATE = {
  title: "Nenhuma informação de Propulsão disponível",
  description:
    "Assim que houver dados do sistema de propulsão desta embarcação, eles aparecerão nesta seção.",
};

/** Os 10 campos, na ordem da HU; a unidade de medida fica no rótulo. */
export const PROPULSAO_FIELDS: DetailFieldDefinition<EmbarcacaoPropulsaoField>[] = [
  { key: "sistemaPropulsao", label: "Sistema de Propulsão" },
  { key: "fabricante", label: "Fabricante" },
  { key: "modelo", label: "Modelo" },
  { key: "eletricoOuMecanico", label: "Elétrico ou Mecânico?" },
  { key: "quantidade", label: "Quantidade" },
  { key: "tipoGeracaoEnergia", label: "Tipo de Geração de Energia" },
  { key: "potencia", label: "Potência (kW)" },
  { key: "marcaLinhaEixo", label: "Marca da Linha de Eixo" },
  { key: "modeloLinhaEixo", label: "Modelo da Linha de Eixo" },
  { key: "atualizacaoPropulsao", label: "Data Atualização Propulsão", format: formatDetailDate },
];
